import { Link } from "react-router-dom";
import { IconWhatsapp, IconLinkedin, IconEmail, IconArrowUp } from "./Icons";

const footerLinks = [
  {
    title: "Products",
    links: [
      { name: "Veterinary Training", path: "/category/veterinary-training" },
      { name: "Surgical Skills", path: "/category/surgical-skills" },
      { name: "Animal Behaviour", path: "/category/animal-behaviour" },
    ],
  },
  {
    title: "Company",
    links: [
      { name: "About Haptone", path: "/about" },
      { name: "Contact Us", path: "/contact" },
    ],
  },
];

export default function Footer() {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <footer className="bg-dark text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 lg:py-20">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          <div className="lg:col-span-2">
            <Link to="/" aria-label="Haptone Home">
              <img
                src="/logo.png"
                alt="Haptone"
                className="h-10 w-auto brightness-0 invert"
                width={120}
                height={40}
              />
            </Link>
            <p className="mt-6 text-white/60 leading-relaxed max-w-md">
              Advancing veterinary education and animal behaviour research
              through innovative simulation models and analysis systems.
            </p>
            <div className="mt-8 flex items-center gap-4">
              <a
                href="https://wa.me/905431712923"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-white/10 rounded-lg flex items-center justify-center hover:bg-[#25D366] transition-colors duration-300"
                aria-label="WhatsApp"
              >
                <IconWhatsapp size={18} />
              </a>
              <a
                href="mailto:info@haptone.com"
                className="w-10 h-10 bg-white/10 rounded-lg flex items-center justify-center hover:bg-secondary transition-colors duration-300"
                aria-label="Email"
              >
                <IconEmail size={18} />
              </a>
              <a
                href="https://linkedin.com/company/haptone"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-white/10 rounded-lg flex items-center justify-center hover:bg-[#0077B5] transition-colors duration-300"
                aria-label="LinkedIn"
              >
                <IconLinkedin size={18} />
              </a>
            </div>
          </div>

          {footerLinks.map((group) => (
            <div key={group.title}>
              <h3 className="text-sm font-semibold uppercase tracking-widest text-white/40 mb-6">
                {group.title}
              </h3>
              <ul className="space-y-4">
                {group.links.map((link) => (
                  <li key={link.path}>
                    <Link
                      to={link.path}
                      className="text-white/60 hover:text-white transition-colors duration-200"
                    >
                      {link.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-white/40 text-sm">
            &copy; {new Date().getFullYear()} Haptone. All rights reserved.
          </p>
          <button
            onClick={scrollToTop}
            className="w-10 h-10 bg-white/10 rounded-lg flex items-center justify-center hover:bg-secondary transition-colors duration-300"
            aria-label="Scroll to top"
          >
            <IconArrowUp size={18} />
          </button>
        </div>
      </div>
    </footer>
  );
}
